var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAhaMainnavFooterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AHA_Logo_2_Colors_copy",
    "data-name": "AHA Logo 2 Colors copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.412,
    height: 36.378,
    viewBox: "0 0 36.412 36.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ball",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16805",
    "data-name": "Path 16805",
    d: "M13.317,11.428A11.125,11.125,0,0,0,17.666,0,18.2,18.2,0,0,0,1.1,11.954a11.125,11.125,0,0,0,12.217-.526Z",
    transform: "translate(0.007)",
    fill: "#c6252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16806",
    "data-name": "Path 16806",
    d: "M10.286,20.576A11.125,11.125,0,0,0,.738,12.91a18.2,18.2,0,0,0,6.27,19.459,11.125,11.125,0,0,0,3.277-11.792Z",
    transform: "translate(-0.006 0.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16807",
    "data-name": "Path 16807",
    d: "M18.115,26.2A11.125,11.125,0,0,0,7.85,32.905a18.2,18.2,0,0,0,20.44.071A11.125,11.125,0,0,0,18.115,26.2Z",
    transform: "translate(0.084 0.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16808",
    "data-name": "Path 16808",
    d: "M35.4,13a11.125,11.125,0,0,0-6.362,19.428A18.083,18.083,0,0,0,35.4,13Z",
    transform: "translate(0.281 0.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16809",
    "data-name": "Path 16809",
    d: "M22.911,11.459a11.125,11.125,0,0,0,12.217.607A18.2,18.2,0,0,0,18.633,0a11.125,11.125,0,0,0,4.278,11.459Z",
    transform: "translate(0.203)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhaMainnavFooterIcon);
export default __webpack_public_path__ + "static/media/aha-mainnav-footer-icon.a699de4acbed25c15528b43756a6d274.svg";
export { ForwardRef as ReactComponent };